export const DEPARTMENTS_MANAGEMENT_ACTION = {
  GET_DEPARTMENTS: 'GET_DEPARTMENTS',
  GET_DEPARTMENTS_SUCCESS: 'GET_DEPARTMENTS_SUCCESS',
  GET_DEPARTMENTS_ERROR: 'GET_DEPARTMENTS_ERROR',
};
// =========================================================================
export const getDepartmets = () => ({
  type: DEPARTMENTS_MANAGEMENT_ACTION.GET_DEPARTMENTS,
});
